export default __webpack_public_path__ + "static/media/11.a2e09cc1.png";